
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 22","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.75 10.274V4.25a.75.75 0 00-.22-.53l-3-3A.75.75 0 0015 .5H4.5a2.25 2.25 0 00-2.25 2.25v3A2.25 2.25 0 000 8v11.25a2.25 2.25 0 002.25 2.25H18a3 3 0 003-3v-5.643c0-1.319-.98-2.409-2.25-2.583zM4.5 2a.75.75 0 00-.75.75v3h1.851c.566 0 1.11.213 1.526.597L8.703 7.8A.75.75 0 009.21 8h5.039a2.25 2.25 0 012.25 2.25v8.25a.75.75 0 00.75-.75V5H15a.75.75 0 01-.75-.75V2H4.5zm5.78 11.47a.75.75 0 11-1.06 1.06L9 14.31V17a.75.75 0 01-1.5 0v-2.69l-.22.22a.75.75 0 11-1.06-1.06l1.5-1.5a.75.75 0 011.06 0l1.5 1.5z"}})])
          )
        }
      }
    